import { render, staticRenderFns } from "./CreateProtocoloModal.vue?vue&type=template&id=04fbb91c&scoped=true"
import script from "./CreateProtocoloModal.vue?vue&type=script&lang=js"
export * from "./CreateProtocoloModal.vue?vue&type=script&lang=js"
import style0 from "./CreateProtocoloModal.vue?vue&type=style&index=0&id=04fbb91c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fbb91c",
  null
  
)

export default component.exports